import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../common';
import { IVehicle } from '../models/i-vehicle';
import { ApiResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  constructor(private http: HttpClient) { }

  GetLastVehiclesByCard(card: string): Observable<ApiResponse<IVehicle[]>> {
    return this.http.get<ApiResponse<IVehicle[]>>(
      `${Constants.API_URL}api/Vehicle/GetLastVehiclesByCard?Card=${card}`)
  }

  GetVehiclesByCard(card: string): Observable<ApiResponse<IVehicle[]>> {
    return this.http.get<ApiResponse<IVehicle[]>>(
      `${Constants.API_URL}api/Vehicle/GetVehiclesByCard?Card=${card}`)
  }
}
